import React from "react";
const Field = [
  "TextField",
  "TextArea",
  "Checkbox",
  "Radio",
  "Dropdown",
  "Number",
  "Currency",
];
const Tools = (props) => {
  return props.contentLenght > 0 ? (
    <div className="tab-tools">
      <div className="is-size-h6 bold pl-5 pt-6">Add To This Tab</div>
      <div className="tab-tools-link" onClick={props.addSectionHandler}>
        Section
      </div>
      <div className="is-size-h6 bold pl-5 pt-8">Alphanumeric Fields</div>
      <div
        className="tab-tools-link"
        onClick={() => props.addFieldHandler(Field[0])}
      >
        Text Field
      </div>
      <div
        className="tab-tools-link"
        onClick={() => props.addFieldHandler(Field[1])}
      >
        Text Area
      </div>
      <div
        className="tab-tools-link"
        onClick={() => props.addOptionTypeFieldHandler(Field[2])}
      >
        Checkbox
      </div>
      <div
        className="tab-tools-link"
        onClick={() => props.addOptionTypeFieldHandler(Field[3])}
      >
        Radio Button
      </div>
      <div
        className="tab-tools-link"
        onClick={() => props.addOptionTypeFieldHandler(Field[4])}
      >
        Dropdown
      </div>
      <div className="is-size-h6 bold pl-5 pt-8">Numeric Fields</div>
      <div
        className="tab-tools-link"
        onClick={() => props.addFieldHandler(Field[5])}
      >
        Number Field
      </div>
      <div
        className="tab-tools-link"
        onClick={() => props.addFieldHandler(Field[6])}
      >
        Currency Field
      </div>
      <div className="tab-tools-link pb-8" onClick={props.addDateHandler}>
        Date Field
      </div>
      {props.contentLenght > 1 ? (
        <div className="tab-tools-footer" onClick={props.deleteTabHandlerModal}>
          Delete This Tab
        </div>
      ) : null}
    </div>
  ) : null;
};

export default Tools;
